
import React from 'react'
import CoverPage from './CoverPage/CoverPage'
import Table from './Table'

const Home = () => {
  return (
    <>
      <CoverPage/>
      <Table/>
    </>
  )
}

export default Home